import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { useChord } from './use-chord';
import { trackCartViewed, trackCollectionClicked, trackEmailCaptured, trackProductClicked, trackProductViewed, trackVariantClicked, } from '../redux/actions/analytics';
/**
 * The `useAnalytics` hook returns a set of functions that sends events to
 * Segment.
 *
 * @example
 *
 * ```javascript
 * import { useAnalytics } from '@chordcommerce/react-autonomy'
 *
 * const ProductLink = ({ children, product }) => {
 *   const { trackProductClicked } = useAnalytics()
 *   const url = `/products/${product.slug}/`
 *
 *   return (
 *     <a href={url} onClick={() => trackProductClicked({ product })}>
 *       {children}
 *     </a>
 *   )
 * }
 * ```
 *
 * @category Hook
 */
export function useAnalytics() {
    const dispatch = useDispatch();
    const { analytics } = useChord();
    const hookMethods = useMemo(() => ({
        chordAnalytics: analytics,
        ...bindActionCreators({
            trackCartViewed,
            trackCollectionClicked,
            trackEmailCaptured,
            trackProductClicked,
            trackProductViewed,
            trackVariantClicked,
        }, dispatch),
    }), [dispatch, analytics]);
    return hookMethods;
}
